import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../store/Store'
import {mediaApi} from './Media.api'
import { IFilterDto, TSort } from '../../common/model/Core.model'

type InitialState = {
  media: {
    error?: string
    loading: boolean
    data?: any
  }
}
const initialState = {
  media: {
    error: undefined,
    loading: false,
    data: undefined,
  },
} as InitialState

export const mediaSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {},
  extraReducers(builder) {
      
  },
})

export const {} = mediaSlice.actions
export default mediaSlice.reducer
